import { PersonDto } from '../../person/models/PersonDto'
import {
    CandidateCompanyConnectionLiteDto,
    CandidateConnectionDto,
    CandidateConnectionLiteDto,
} from './CandidateConnectionDto'

export interface GenericCandidateLite {
    candidatePersonId: string
    rank?: number
    present?: PresentCandidateValues
}

export type GenericCandidateLiteWithExtras =
    | HelixCandidateLiteDto
    | CandidateLiteDto

export type CandidateDto = {
    candidatePerson: PersonDto // candidate
    present?: PresentCandidateValues // whether the TA wants to present this candidate to the hiring manager
    connections: CandidateConnectionDto[] // connections to hiring managers and persons that have given feedback
    //  note that there could be people in here that are not in the interviewing team (if that's the case
    //  then they have given feedback but are not part of the interviewing team)
}

export type CandidateRankedDto = {
    rankingScoreNormalised: number
} & CandidateDto

export type CandidateLiteDto = {
    candidatePersonId: string
    present?: PresentCandidateValues
    contacted: boolean
    contactedDate?: Date
    interested?: InterestedValues
    interestedDate?: Date
    connections: CandidateConnectionLiteDto[]
    companyConnections: CandidateCompanyConnectionLiteDto[]
    // the final, normalised ranking score for this candidate
    rankingScore: number
    closenessScore: number
    jobRelevanceScore: number
    jobRelevanceRawScore: number
    jobRelevanceJobTitle: string
}

export type HelixCandidateLiteDto = {
    candidatePersonId: string
    present?: PresentCandidateValues
    // companyConnections: CandidateCompanyConnectionLiteDto[]
    // the final, normalised ranking score for this candidate
    rank: number
    booleanSearchScoreNormalised?: number
    aggregatedRelationshipScore?: number
    combinedScore?: number
    llmRelevanceScoreScore?: number
    llmRelevanceScoreReason?: string
    llmRelevanceScoreTopPick?: boolean
}

export enum PresentCandidateValues {
    YES = 'yes',
    NO = 'no',
}

export enum InterestedValues {
    YES = 'yes',
    NO = 'no',
}
